import api from "../../services/api";
import {
  GET_WORKERS_FAILURE,
  GET_WORKERS_REQUEST,
  GET_WORKERS_SUCCESS,
} from "./ActionType";

const getWorkerRequest = () => {
  return {
    type: GET_WORKERS_REQUEST,
  };
};

const getWorkerSuccess = (worker) => {
  return {
    type: GET_WORKERS_SUCCESS,
    payload: worker,
  };
};

const getWorkerFailure = (error) => {
  return {
    type: GET_WORKERS_FAILURE,
    payload: error,
  };
};

export const getWorkers = () => async (dispatch) => {
  dispatch(getWorkerRequest());
  try {
    const response = await api.get("/admin/workers", {
      withCredentials: true,
    });
    dispatch(getWorkerSuccess(response.data));
  } catch (error) {
    dispatch(getWorkerFailure(error));
  }
};
